import React, { FunctionComponent } from 'react';

import { Breadcrumb } from '@gojob/cms';
import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import Icon from '@gojob/ui-bits/Icon';
import ChevronRight from '@gojob/ui-bits/Icons/ChevronRight';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import Typography from '@gojob/ui-bits/Typography';
import Link from '../Link';

export interface BreadcrumbsProps extends FlexProps<'div'> {
  items: Breadcrumb[];
}

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    link: {
      display: 'flex',
      textDecoration: 'none',
      ':hover, :focus, :active': {
        textDecoration: 'underline',
      },
    },
    icon: {
      marginTop: spacing(-0.3),
    },
  };
};

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = (props) => {
  const { items, ...flexProps } = props;

  const classes = useStyles();

  if (!items?.length) {
    return null;
  }

  const lastItem = items.slice(-1)[0];
  const otherItems = items.slice(0, -1);

  return (
    <Flex flexDirection="row" flexWrap="wrap" justifyContent="start" {...flexProps}>
      <Flex flexWrap="wrap">
        {otherItems.map(({ label, to }, i) => {
          let extraProps = {};
          if (to) {
            extraProps = { to, as: Link };
          }
          return (
            <Text
              inactive
              key={i}
              data-testid="Breadcrumbs-item"
              variant="message4"
              {...extraProps}
              css={classes.link}
            >
              {label} <Icon color="lightIcon" as={ChevronRight as any} size={4} css={classes.icon} />
            </Text>
          );
        })}
      </Flex>
      <Typography variant="messageExtraSmall" color="primary">
        {lastItem.label}
      </Typography>
    </Flex>
  );
};

export default Breadcrumbs;
